export default "__VITE_ASSET__oTJ_zSpm__"